import * as React from "react";

interface IProps {
	value?: {value: string};
}

export const CustomFieldPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{props.value ? props.value.value : "-"}</span>
	);
};